import { render, staticRenderFns } from "./helpInfo.vue?vue&type=template&id=3c274f38&"
import script from "./helpInfo.vue?vue&type=script&lang=js&"
export * from "./helpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports